import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=fda60028&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda60028",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fda60028')) {
      api.createRecord('fda60028', component.options)
    } else {
      api.reload('fda60028', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=fda60028&scoped=true&", function () {
      api.rerender('fda60028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2529HyhDyRHGb/JS/comp/SearchFilterTokens.vue"
export default component.exports